<template>
  <div class="task-processing">
    <h2 style="padding: 0 16px">任务办理</h2>
    <ProTable ref="proTableRef" :columns="tableColumns" :request="loadData">
      <template slot="operation" slot-scope="{ row, index }">
        <el-button size="small" @click="handleAction(row, 'view')">查看</el-button>
        <el-button
          v-if="
            (identityObj.identityTypeCode == 15 && row.taskStatus == 0 && row.taskType == 2) ||
            (identityObj.identityTypeCode == 18 && row.taskStatus == 3 && row.taskType == 2) ||
            (identityObj.identityTypeCode == 18 && row.taskStatus == 0 && row.taskType == 1)
          "
          type="primary"
          size="small"
          @click="handleAction(row, 'process')"
        >
          办理
        </el-button>
      </template>
    </ProTable>

    <!-- 贷款详情弹窗 -->
    <LoanDetailDialog
      ref="loanDetailDialogRef"
      :selectedLoanRow="selectedLoanRow"
      :actionType="actionType"
      @confirm="handleConfirm"
    />
  </div>
</template>

<script>
import LoanDetailDialog from './components/LoanDetailDialog.vue'
import ProTable from '@/components/table/ProTable.vue'
import { getTaskList } from '@/api/taskProcessing'
import { mapGetters } from 'vuex'

export default {
  name: 'TaskProcessing',
  components: {
    LoanDetailDialog,
    ProTable
  },
  data() {
    return {
      selectedLoanRow: null,
      actionType: '',
    }
  },
  computed: {
    ...mapGetters(['identityObj']),
    // 表格列配置
    tableColumns() {
      return [
        {
          prop: 'companyName',
          inTable: false,
          searchable: true,
          search: {
            el: 'input',
            props: {
              placeholder: '请输入贷款人'
            }
          }
        },
        { prop: 'taskId', label: '任务编号', width: 120 },
        { prop: 'taskTypeName', label: '任务类型', width: 120 },
        { prop: 'warehouseCompany', label: '质押物仓储公司' },
        { prop: 'borrower', label: '贷款人' },
        { prop: 'loanAmount', label: '贷款额度', width: 100 },
        { prop: 'submitter', label: '任务提交人', width: 100 },
        { prop: 'submitTime', label: '提交时间', width: 150 },
        { prop: 'taskStatusName', label: '状态', width: 100 },
        { prop: 'operation', label: '操作', fixed: 'right', width: 200 }
      ]
    }
  },
  methods: {
    // 获取表格数据
    async loadData(params = {}) {
      try {
        const apiParams = {
          pageNum: params.page || 1,
          pageSize: params.pageSize || 10,
          companyName: params.companyName || ''
        }
        const res = await getTaskList(apiParams)
        console.log('API Response:', res)

        const pageData = res.data
        return {
          success: true,
          data: pageData?.records || [],
          total: Number(pageData?.total) || 0,
          page: Number(pageData?.current) || 1,
          pageSize: Number(pageData?.size) || 10
        }
      } catch (error) {
        console.error('获取任务列表失败', error)
        return {
          success: false,
          data: [],
          total: 0,
          page: 1,
          pageSize: 10
        }
      }
    },

    handleAction(row, action) {
      this.selectedLoanRow = row
      this.actionType = action
      this.$nextTick(() => {
        this.$refs.loanDetailDialogRef.handleOpen()
      })
    },

    handleConfirm() {
      this.$refs.proTableRef.handleRefresh()
    }
  }
}
</script>

<style lang="less" scoped>
.task-processing {
  padding: 20px;
  min-height: 100vh;
}
</style>
